<template>
    <div class="prod-detail-page">
        <img class="prodPic" :src="goodItem.cover_image" alt="">
        <div class="prod-name">{{ goodItem.goods_name }}</div>
        <div class="prod-price-info">
            <div class="prodAmt">
                <b>¥</b><span>{{ goodItem.price / 100 }}</span><label>原价¥{{ goodItem.underlined_price / 100 }}</label>
            </div>
            <div class="prod-left-count">销售量：{{goodItem.goods_expands.sale_count}}件  浏览量：{{goodItem.goods_expands.view_count}}次</div>
        </div>
        <div class="prod-inventory">库存：剩余{{ goodItem.inventory || 0 }}件</div>
        <div class="prod-evaluate">
            <van-cell title="评论" is-link :to="'/commentList?goodsId=' + this.$route.query.goodsId" value="更多" />
            <div v-for="item in commentsData" :key="item.order_id">
                <commentItem :item="item" />
            </div>
        </div>
        <div class="prod-more-info">
            <div class="prod-more-info-title">
                <div>- - - - 商品详情 - - - -</div>
            </div>
            <div class="prod-content-item" v-for="(item, index) in contentData" :key="'contentKey' + index">
                <img class="prodPic" :src="item.images" alt="">
                <p v-if="item.content" class="info-chapter">{{item.content}}</p>
            </div>
        </div>
        <div class="prod-bottom-btn" @click="toBuy">立&nbsp;&nbsp;&nbsp;即&nbsp;&nbsp;&nbsp;购&nbsp;&nbsp;&nbsp;买</div>
        <Popup v-model="showError" destroy-on-close round>
            <div class="error-box">{{ errorMsg }}</div>
        </Popup>
    </div>
</template>
<script>
import commentItem from '../components/commentItem.vue'
import { goodsDetail, comments } from '../api/index.js'
import { Popup } from 'vant';
export default {
    name: 'prdDetailPage',
    components: {
        commentItem,
        Popup
    },
    data(){
        return {
            goodItem: {
                goods_expands: {}
            },
            commentsData: [],
            contentData: [],
            errorMsg: '',
            showError: false
        }
    },
    activated() {
        console.log(this.$route.query)
        this.getDetail(this.$route.query.goodsId)
        this.getComments(this.$route.query.goodsId)
    },
    methods: {
        getDetail(e){
            goodsDetail({goods_id: e}).then(res => {
                console.log(res)
                if(res.message == 'success') {
                    this.goodItem = res.data
                    let content = res.data.goods_details ? res.data.goods_details.content : ''
                    if( content ) {
                        this.contentData = JSON.parse(content)
                        console.log('this.contentData======>', this.contentData)
                    }
                }
            })
        },
        getComments(e){
            comments({goods_id: e, page: 1, page_size:1}).then(res => {
                console.log(res)
                if(res.message == 'success') {
                    this.commentsData = res.data.data || []
                }
            })
        },
        toBuy(){
            if (this.goodItem.inventory == 0) {
                this.errorMsg = '库存不足，如需购买请联系管理员了解详情！'
                this.showError = true
                return
            }
            this.$EventBus.$emit('goodItem', this.goodItem)
            this.$router.push({path: '/createOrder', query: {goodsId: this.goodItem.goods_id}})
        },
    },
}
</script>
<style>
    .prod-detail-page {
        width: 100vw;
        background: #f9f9f9;
        padding-bottom: 36px;
    }
    .prodPic {
        width: 100%;
        display: block;
    }
    .prod-name {
        font-size: 18px;
        line-height: 24px;
        text-indent: 8px;
        color: #000;
        padding: 8px 0;
        background: #fff;
    }
    .prod-price-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding-bottom: 6px;
    }
    .prodAmt {
        display: flex;
        align-items: flex-end;
        padding-left: 8px;
    }
    .prodAmt > b {
        font-size: 10px;
        color: #EC899C;
        font-weight: 700;
    }
    .prodAmt > span {
        font-size: 14px;
        color: #EC899C;
        font-weight: 700;
        margin-right: 4px;
    }
    .prodAmt > label {
        font-size: 12px;
        color: #999;
        text-decoration: line-through;
    }
    .prod-left-count {
        font-size: 12px;
        color: #999;
        margin-right: 8px;
    }
    .prod-inventory {
        background: #fff;
        padding-right: 8px;
        margin-bottom: 16px;
        font-size: 12px;
        color: #999;
        padding-bottom: 6px;
        text-align: right;
    }
    .prod-more-info {
        width: 100vw;
        background: #fff;
    }
    .info-chapter {
        padding: 8px;
        font-size: 14px;
        color: #000;
    }
    .prod-evaluate {
        margin-bottom: 20px;
    }
    
    .prod-more-info-title {
        display: flex;
        justify-content: center;
        background: #f9f9f9;
    }
    .prod-more-info-title > div {
        color: #000;
        font-size: 18px;
        margin-bottom: 8px;
    }
    .prod-bottom-btn {
        height: 36px;
        width: 90vw;
        background: #13A1EE;
        color: #fff;
        border-radius: 24px;
        line-height: 36px;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        position: fixed;
        bottom: 16px;
        left: 5vw;
        box-shadow: 0 4px 6px 0 rgba(211,211,211,0.50);
    }
    .error-box {
        padding: 16px;
        font-size: 14px;
        text-align: center;
    }
</style>
